import React from "react";
import ReactDOM from "react-dom";
import SSORequestAccountForm from "./SSORequestAccountForm.jsx";

export function initSSORequestAccountForm() {
  if (!window.grecaptcha) {
    const script = document.createElement("script");
    // Site Key owned by Stewart Title
    // As of August 2025, was not configured to work with localhost requests
    // so this will never submit successfully in Storybook.
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Lc8rwYaAAAAAGsJKqZhD-FjPHtuq1D56kx47AnM";
    document.body.appendChild(script);
  }
  document
    .querySelectorAll(".js-sso-request-account-form")
    .forEach((mount, i) => {
      // Read data attributes from mount element
      const dataset = mount.dataset;

      // Determine mode from data-mode attribute (default: "register")
      const mode = dataset.mode || "register";

      // Determine site variant (e.g. "stewartcom") for field-level opt-outs.
      const variant = dataset.variant || "";

      // Parse initial data from data-initial-data attribute if present
      // Expected format: JSON string
      let initialData = null;
      if (dataset.initialData) {
        try {
          initialData = JSON.parse(dataset.initialData);
        } catch (e) {
          console.error("Failed to parse initial data:", e);
        }
      }

      ReactDOM.render(
        <SSORequestAccountForm mode={mode} initialData={initialData} variant={variant} />,
        mount,
      );
    });
}
